<template>

<div v-if="getWhiteLabel === 'CASHFORCE'">
    <footer>
        <div class="container-fluid py-2">
            <div class="row">
                <div class="col-6 text-center">
                    <h6 class="regular c-nmidone">
                        © {{actualYear}} Cashforce. Todos os direitos reservados.
                        <!-- <span :class="`c-${getPrimaryColor}four pointer footer-link" @click="dialogVisible = true`"> 
                            Termos de uso e política de privacidade.
                        </span> -->
                    </h6>
                </div>
            </div>
        </div>
    </footer>
    <Contract :dialogVisible="dialogVisible" @closeModal="dialogVisible = false" />
</div>

</template>

<script>
import Contract from '@/components/modals/Contract'
const dayjs = require('dayjs')
export default {
    components: {
        Contract
    },
    data() {
        return {
            dialogVisible:false
        }
    },
    computed: {
        actualYear() {
            return dayjs().year()
        }
    },
    methods: {

    }
}
</script>

<style lang="scss">
    .footer-link {
        &:hover {
            text-decoration: underline;
        }
    }
</style>
